import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link, BrowserRouter, } from 'react-router-dom';
import Start from './Pages/start'
// import Home from './Pages/home'
// import StepForm from './Pages/stepform'
import Contest from './Pages/contest'
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"

function App() {
  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Contest/>} />
        <Route path="/thankyou" element={<Start/>} />
        {/* <Route path="/wishacolorcontest" element={<Home/>} />
        <Route path="/stepform" element={<StepForm/>} />
        <Route path="/contest" element={<Contest/>} /> */}
      </Routes>
      </Router>
    <Analytics/>
    <SpeedInsights/>
    </>
  );
}

export default App;
